import React, { Suspense, lazy } from "react"
import { type RouteObject, Navigate } from "react-router-dom"

import GuestLayout from "@components/layout/Guest.layout"
import PublicRoute from "@components/layout/PublicRoute"
import ErrorBoundary from "@pages/ErrorBoundary"
import { PageLoader } from "@components/ui"

const ForgotPasswordPage = lazy(() => import("@pages/Auth/ForgotPassword.page"))
const ResetPasswordPage = lazy(() => import("@pages/Auth/ResetPassword.page"))
const LoginAdminPage = lazy(() => import("@pages/Auth/LoginAdmin.page"))
const RegisterPage = lazy(() => import("@pages/Auth/Register.page"))
const LoginPage = lazy(() => import("@pages/Auth/Login.page"))
// const VerifyEmailPage = lazy(() => import("@pages/Auth/VerifyEmail.page"))

export const AuthRouter: RouteObject[] = [
  {
    path: "/",
    element: (
      <PublicRoute>
        <ErrorBoundary>
          <GuestLayout />
        </ErrorBoundary>
      </PublicRoute>
    ),
    children: [
      {
        path: "/login",
        element: (
          <Suspense fallback={<PageLoader text="Loading login..." />}>
            <LoginPage />
          </Suspense>
        ),
      },
      {
        path: "/register",
        element: (
          <Suspense fallback={<PageLoader text="Loading registration..." />}>
            <RegisterPage />
          </Suspense>
        ),
      },
      {
        path: "/forgot-password",
        element: (
          <Suspense fallback={<PageLoader text="Loading password recovery..." />}>
            <ForgotPasswordPage />
          </Suspense>
        ),
      },
      {
        path: "/reset-password",
        element: (
          <Suspense fallback={<PageLoader text="Loading password reset..." />}>
            <ResetPasswordPage />
          </Suspense>
        ),
      },
      {
        path: "/admin",
        element: <Navigate to="/admin/login" />,
      },
      {
        path: "/admin/login",
        element: (
          <Suspense fallback={<PageLoader text="Loading admin login..." />}>
            <LoginAdminPage />
          </Suspense>
        ),
      },
      // {
      //   path: "/verify-email",
      //   element: (
      //     <Suspense fallback={<PageLoader text="Loading email verification..." />}>
      //       <VerifyEmailPage />
      //     </Suspense>
      //   ),
      // },
    ],
  },
]
